import React from "react";
import { Sunrise, Sunset, Moon, Sun, AlertTriangle, Sparkles } from "lucide-react";

const Item = ({ label, value }) => (
  <div className="rounded-xl bg-secondary/60 border border-border/60 p-3">
    <p className="text-[10px] uppercase tracking-widest text-muted-foreground">{label}</p>
    <p className="font-serif text-base font-semibold mt-0.5 leading-tight">{value}</p>
  </div>
);

export default function PanchangCard({ p, compact }) {
  if (!p) return null;
  return (
    <div data-testid="daily-panchang-card" className="rounded-2xl bg-card/95 border border-accent/40 shadow-sm p-6 relative overflow-hidden">
      <div className="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-accent/10 blur-2xl" />
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-accent font-semibold">Today's Panchang</p>
          <p className="font-serif text-lg font-semibold">{p.date}</p>
        </div>
        <span className="font-devanagari text-2xl text-accent">ॐ</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
        <Item label="Vaar" value={p.vaar} />
        <Item label="Tithi" value={p.tithi} />
        <Item label="Paksha" value={p.paksha} />
        <Item label="Nakshatra" value={p.nakshatra} />
        <Item label="Yoga" value={p.yoga} />
        <Item label="Karana" value={p.karana} />
      </div>

      {!compact && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 mt-3">
            <div className="rounded-xl bg-secondary/60 border border-border/60 p-3 flex items-center gap-2"><Sunrise className="h-4 w-4 text-accent" /><div><p className="text-[10px] uppercase text-muted-foreground">Sunrise</p><p className="font-semibold text-sm">{p.sunrise}</p></div></div>
            <div className="rounded-xl bg-secondary/60 border border-border/60 p-3 flex items-center gap-2"><Sunset className="h-4 w-4 text-accent" /><div><p className="text-[10px] uppercase text-muted-foreground">Sunset</p><p className="font-semibold text-sm">{p.sunset}</p></div></div>
            <div className="rounded-xl bg-secondary/60 border border-border/60 p-3 flex items-center gap-2"><Moon className="h-4 w-4 text-accent" /><div><p className="text-[10px] uppercase text-muted-foreground">Moonrise</p><p className="font-semibold text-sm">{p.moonrise}</p></div></div>
            <div className="rounded-xl bg-secondary/60 border border-border/60 p-3 flex items-center gap-2"><Sun className="h-4 w-4 text-accent" /><div><p className="text-[10px] uppercase text-muted-foreground">Moonset</p><p className="font-semibold text-sm">{p.moonset}</p></div></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
            <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-3">
              <p className="flex items-center gap-1.5 text-xs font-semibold text-emerald-600 uppercase tracking-wide mb-2"><Sparkles className="h-3.5 w-3.5" /> Auspicious</p>
              {p.auspicious.map((a) => (<p key={a.name} className="text-sm flex justify-between"><span className="text-muted-foreground">{a.name}</span><span className="font-medium">{a.time}</span></p>))}
            </div>
            <div className="rounded-xl border border-destructive/30 bg-destructive/5 p-3">
              <p className="flex items-center gap-1.5 text-xs font-semibold text-destructive uppercase tracking-wide mb-2"><AlertTriangle className="h-3.5 w-3.5" /> Inauspicious</p>
              {p.inauspicious.map((a) => (<p key={a.name} className="text-sm flex justify-between"><span className="text-muted-foreground">{a.name}</span><span className="font-medium">{a.time}</span></p>))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
